var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"header-wrapper"},[_c('Header',{staticClass:"header"})],1),_c('div',{staticClass:"content"},[_c('OnePage'),_c('TowPage'),_c('ThreePage'),_c('FooterSection')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }